import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Team } from 'src/app/models/team';
import { Firestore } from '@angular/fire/firestore';
import { addDoc, collection, doc, setDoc } from 'firebase/firestore';

@Component({
  selector: 'app-team-manage-dialog',
  templateUrl: './team-manage-dialog.component.html',
  styleUrls: ['./team-manage-dialog.component.css']
})
export class TeamManageDialogComponent implements OnInit {
  submitting: boolean;
  constructor(private firestore: Firestore,
    public auth: AuthService,
    private dialogRef: MatDialogRef<TeamManageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public keySet: Team) { }


  ngOnInit() {
    this.submitting = false;
  }

  onSubmit() {
    this.submitting = true;
    this.request();
  }

  async request() {
    if (this.keySet.id === '') {
      await addDoc(collection(this.firestore, 'team'), this.keySet);
    } else {
      await setDoc(doc(this.firestore, 'team', this.keySet.id), this.keySet);
    }
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
